import React from 'react';
import classNames from 'classnames/bind';

import { useTranslation } from 'react-i18next';
import { ButtonWithIconLeft, ButtonWithIconOnly } from 'koba/components/Button';
import { Tooltip } from '@thinkific/toga-react';
import { getAttachmentButtons } from 'constants/attachmentButtons';
import Icon from 'koba/components/Icon';
import styles from './AttachmentButtons.module.scss';

const cx = classNames.bind(styles);

interface AttachmentButtonProps {
  isDisabled?: boolean;
  isCommentForm?: boolean;
  onBtnClick: (attachmentType: string) => void;
}

const AttachmentButtons = ({
  isDisabled,
  isCommentForm,
  onBtnClick,
}: AttachmentButtonProps) => {
  const { t } = useTranslation();

  const attachmentButtonsList = getAttachmentButtons(t);

  const renderPostButtons = () => {
    return attachmentButtonsList.map(
      ({ title, attachmentType, iconName, dataQA }) => (
        <ButtonWithIconLeft
          appearance="ghost"
          data-qa={dataQA}
          isDisabled={isDisabled}
          key={title}
          size="small"
          onClick={() => onBtnClick(attachmentType)}
        >
          <Icon name={iconName} />
          <span>{title}</span>
        </ButtonWithIconLeft>
      )
    );
  };

  const renderCommentButtons = () => {
    return attachmentButtonsList.map(
      ({ tooltipTitle, attachmentType, iconName, dataQA }) => (
        <Tooltip
          className={cx('attachment__buttons__comment')}
          key={tooltipTitle}
          title={isDisabled ? '' : tooltipTitle}
        >
          <ButtonWithIconOnly
            appearance="knockout"
            data-qa={dataQA}
            isDisabled={isDisabled}
            key={tooltipTitle}
            onClick={() => onBtnClick(attachmentType)}
          >
            <Icon name={iconName} />
          </ButtonWithIconOnly>
        </Tooltip>
      )
    );
  };

  return (
    <div className={cx('attachment')} data-qa="attachment">
      <div
        className={cx('attachment__buttons', {
          'attachment__buttons--icon-only': isCommentForm,
        })}
      >
        {isCommentForm ? renderCommentButtons() : renderPostButtons()}
      </div>
    </div>
  );
};

export { AttachmentButtons };
